import { IKnmInspectorType } from 'APIPackage/CatalogsModule/interfaces/IKnmInspectorType';

export const createKnmInspectorTypeSelectOption = (knmInspectorType: IKnmInspectorType) => ({
  ...knmInspectorType,
  label: knmInspectorType.name,
  value: knmInspectorType.code,
});
